module.exports = __webpack_public_path__ + "img/Concrete.ff3d28a0.svg";